import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { CmsService } from 'src/app/services/api/cms.service';
import { DomSanitizer } from '@angular/platform-browser';
import { WinService } from 'src/app/services/win.service';

@Component({
	selector: 'app-about',
	templateUrl: './about.component.html',
	styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit, OnChanges {

	featureIcon: any;
	featureBG: string = 'bg-yellow';

	/* the block ID to be used default is 2 */
	staticBlockId: any = 46;
	@Input() blockId: any = 46;

	/* the block data was fetched */
	block: any = null;


	isFired: boolean = false;

	constructor(
		public winService: WinService,
		public cms: CmsService,
		public sanitizer: DomSanitizer
	) { }

	ngOnInit() {
		this.getBlock();
	}

	ngOnChanges(){
		this.getBlock();
	}

	getBlock() {
		if (!this.isFired || (this.isFired && this.staticBlockId != this.blockId)) {
			this.staticBlockId = this.blockId;
			this.isFired = true;
			this.cms.getBlock(this.blockId, false, true).then(f => {
				this.block = this.cms.cms['block_' + this.blockId];
				this.block.content.youembedlink = this.sanitizer.bypassSecurityTrustResourceUrl(this.block.content.youembedlink);
			});
		}
		return false;
	}
}
